import { normalize, denormalize } from 'normalizr';

import { dispatch, getState } from '../store';
import { GenderService } from '../services/GenderService';
import { GenderSchema } from './schemas';

/**
 * Typings
 */

function normalizeData(data) {
  const normalizedData = normalize(data, Array.isArray(data) ? [GenderSchema] : GenderSchema);
  dispatch.entities.mergeEntities(normalizedData.entities);

  return normalizedData.result;
}

const INITIAL_STATE = [];

/**
 * Model
 */
export const model = {
  name: 'genders',
  state: INITIAL_STATE,
  reducers: {
    'session/reset': () => INITIAL_STATE,

    set: (state, payload) => payload,
  },
  selectors: {
    get: (state) => denormalize(state, [GenderSchema], getState().entities),
  },
  effects: {
    async fetchAll() {
      const response = await GenderService.get();

      if (response.ok) {
        this.set(normalizeData(response.data));
      }

      return response;
    },
  },
};
